<template lang="html">
    <div v-if="params && params.isActive">
        <ModalDefault size="s" :with-content="true" @close="close();" :theme="true" :fix-height="false" :fix-width="false" :loading="loading">
            <template slot="main">
                <section class="change-access">
                    <p class="modal-title">{{ $t("catalogForecast.rechallengeMarketsModal.title") }}</p>
                    <p class="modal-message">{{ $t("catalogForecast.rechallengeMarketsModal.message") }}</p>

                    <div class="row d-flex align-items-center">
                        <div class="col-auto">
                            <ClientColorButton class="mt-4" :inactive-color="true" @click="selectAll();">{{
                                $t("common.selectAll")
                            }}</ClientColorButton>
                        </div>
                        <div class="col-auto">
                            <ClientColorButton class="mt-4" :inactive-color="true" @click="selectNone();">{{
                                $t("common.selectNone")
                            }}</ClientColorButton>
                        </div>
                    </div>

                    <div class="row my-3 checkbox-zones">
                        <div class="col-12" v-for="bz in params.brandZones">
                            <label
                                :for="'checkbox_zone_' + bz.zone.id"
                                class="label-checkbox pointer mb-0 d-flex align-items-center justify-content-start py-2"
                            >
                                <span
                                    v-show="checkedZones.includes(bz.zone.id)"
                                    @click="checkZone(bz.zone.id, false);"
                                    class="rem3rch-checkbox rem3rch-checkbox-s"
                                >
                                    <i class="fa fa-check"></i>
                                </span>
                                <span
                                    v-if="!checkedZones.includes(bz.zone.id)"
                                    @click="checkZone(bz.zone.id, true);"
                                    class="rem3rch-checkbox rem3rch-checkbox-s"
                                ></span>
                                <span class="ml-4 checkbox-label">{{ bz.zone.name }}</span>
                            </label>
                        </div>
                    </div>

                    <div class="my-3 row message">
                        <label for="message-input" class="col-12"
                            >{{ $t("catalogForecast.rechallengeMarketsModal.messageLabel") }} <span>*</span></label
                        >
                        <div class="col-12"><textarea id="message-input" rows="5" v-model="message"></textarea></div>
                    </div>

                    <div class="row d-flex justify-content-end">
                        <ClientColorButton
                            :inactiveColor="!isValidateForm()"
                            :background-color="currentBrand.linksColor"
                            @click="rechallengeMarkets();"
                            :disabled="!isValidateForm()"
                            class="mr-3"
                        >
                            {{ $t("catalogForecast.rechallenge") }}
                        </ClientColorButton>
                        <ClientColorButton :inactiveColor="true" @click.prevent="close();">{{ $t("actions.cancel") }}</ClientColorButton>
                    </div>
                </section>
            </template>
        </ModalDefault>
    </div>
</template>

<script lang="js">
import ModalDefault from "@/components/ui/ModalDefault";
import {mapState} from "vuex";
import DefaultTextareaInputBloc from "@/components/ui/Form/DefaultTextareaInputBloc";
import rechallengeService from "@/services/cfRechallenge";

export default {
    components: {DefaultTextareaInputBloc, ModalDefault},
    props: [
        'params'
    ],
    data () {
        return {
            loading: false,
            checkedZones: [],
            message: null
        }
    },
    created() {
        this.selectAll();
        this.params.brandZones.sort((bz1, bz2) =>{
            return bz1.zone.name.toLowerCase() > bz2.zone.name.toLowerCase() ? 1 : -1;
        });
    },
    methods: {
        rechallengeMarkets() {
            this.loading = true;

            const payload = {
              zones: this.checkedZones,
              period: this.params.periodId,
              message: this.message
            };

            rechallengeService.create(payload).then(() => {
                this.dialogSuccess('success')
                this.loading = false;
                this.$emit('success');
                this.close();
            })
            .catch(() => {
                this.dialogError('error');
                this.loading = false;
            });
        },
        selectAll() {
            this.params.brandZones.forEach(bz => {
                if (!this.checkedZones.includes(bz.zone.id)) {
                    this.checkedZones.push(bz.zone.id);
                }
            });
        },
        selectNone() {
            this.checkedZones = [];
        },
        checkZone(zoneId, add) {
            if (add) {
                this.checkedZones.push(zoneId);
            } else {
                this.checkedZones.splice(this.checkedZones.indexOf(zoneId), 1);
            }
        },
        isValidateForm() {
          return this.checkedZones.length && this.message;
        },
        close() {
            this.params.isActive = false
            this.$emit('close');
        }
    },
    computed: {
        ...mapState("currentUser", ["currentBrand"]),
    }
}
</script>

<style scoped lang="scss">
.modal-message {
    font-size: 20px;
    font-weight: bold;
}
.checkbox-zones {
    overflow-y: auto;
    max-height: 50vh;
    .checkbox-label {
        font-size: 16px;
        color: #707070;
        text-transform: initial;
    }
}
.message {
    label {
        font-size: 16px;
        font-weight: bold;
        span {
            color: red;
        }
    }
    textarea {
        width: 100%;
        padding: 5px;
    }
}
</style>

<style lang="scss">
.modal-title {
    text-transform: initial !important;
}
</style>



// WEBPACK FOOTER //
// RechallengeMarkets.vue?39214479